import { render } from "./CategoryBarChart.vue?vue&type=template&id=bb7347ae&scoped=true"
import script from "./CategoryBarChart.vue?vue&type=script&lang=js"
export * from "./CategoryBarChart.vue?vue&type=script&lang=js"

import "./CategoryBarChart.vue?vue&type=style&index=0&id=bb7347ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7347ae"]])

export default __exports__